import {FC, ReactNode} from "react";
import {FormControlLabel, Switch, SwitchProps} from "@mui/material";

type TCommonSwitch = SwitchProps & {
    label?: string | ReactNode,
}

const CommonSwitch: FC<TCommonSwitch> = ({label, ...props}) => {

    return (label && label !== '') ? (
            <FormControlLabel
                control={<Switch sx={{ m: 1 }} {...props} />}
                label={label}
            />
        ) : (
            <Switch {...props} />
        )
}

export default CommonSwitch;
